import { ActionPaths } from '@src/widgets/RiskRecords/ActionPaths';
import { AttributeSummary } from '@src/widgets/RiskRecords/AttributeSummary';
import { CoverageStatus } from '@src/widgets/RiskRecords/CoverageStatus';
import { Dates } from '@src/widgets/RiskRecords/Dates';
import { Eimp } from '@src/widgets/RiskRecords/Eimp';
import { IreRecordDetail } from '@src/widgets/RiskRecords/IreRecordDetail';
import { IreRelatedEntities } from '@src/widgets/RiskRecords/IreRelatedEntities';
import { RemediationEvents } from '@src/widgets/RiskRecords/RemediationEvents';
import { Tags } from '@src/widgets/RiskRecords/Tags';
import { TrustedValueHistory } from '@src/widgets/RiskRecords/TrustedValueHistory';

/**
 * widgets
 *
 * @type {{"action-paths": {accessor: string, component: ((function({handleSearch?: function(), riskRecord?: {}}): Element)|*), description: string, icon: string, order: number, title: string}, "attribute-summary": {accessor: string, component: ((function({options?: {}, riskRecord?: {}}): Element)|*), description: string, icon: string, order: number, title: string}, "coverage-status": {accessor: string, component: ((function({riskRecord?: {}}): Element)|*), description: string, icon: string, order: number, title: string}, dates: {accessor: string, component: ((function({riskRecord?: {}}): Element)|*), description: string, icon: string, order: number, title: string}, eimp: {accessor: string, component: ((function({riskRecord: *}): Element)|*), description: string, icon: string, order: number, title: string}, "remediation-events": {accessor: string, component: ((function({riskRecord?: {remediation: {remediationEvents: []}}}): Element)|*), description: string, icon: string, order: number, title: string}, tags: {accessor: string, component: ((function({assets?: {}, riskRecord?: {}}): Element)|*), description: string, icon: string, order: number, title: string}, "trusted-value-history": {accessor: string, component: ((function({riskRecord?: {}}): Element)|*), description: string, icon: string, order: number, title: string}}}
 */
export const widgets = {
  'action-paths': {
    accessor: 'action-paths',
    component: ActionPaths,
    description: 'History of Action Paths EID has been assigned to.',
    icon: 'create_new_folder',
    order: 4,
    title: 'Action Paths',
  },
  'attribute-summary': {
    accessor: 'attribute-summary',
    component: AttributeSummary,
    description: 'Identified Attribute with Identity Risk.',
    icon: 'attribution',
    order: 3,
    title: 'Attribute Summary',
  },
  'coverage-status': {
    accessor: 'coverage-status',
    component: CoverageStatus,
    description: 'History of member coverages.',
    icon: 'medical_services',
    order: 2,
    title: 'Coverage Status',
  },
  dates: {
    accessor: 'dates',
    component: Dates,
    description: 'Date history for EID in Rem Hub.',
    icon: 'date_range',
    order: 10,
    title: 'Dates',
  },
  eimp: {
    accessor: 'eimp',
    component: Eimp,
    description: 'EIMP Merge/Split History and Source data.',
    icon: 'dns',
    order: 6,
    title: 'EIMP',
  },
  'ire-record-detail': {
    accessor: 'ire-record-detail',
    component: IreRecordDetail,
    description: '',
    icon: 'info',
    order: -2,
    title: 'IRE Record Detail',
  },
  // 'event-timeline': {
  //   accessor: 'event-timeline',
  //   component: EventTimeline,
  //   description: 'Timeline of key risk and remediation events for this EID.',
  //   icon: 'timeline',
  //   order: 1,
  //   title: 'Event Timeline',
  // },
  'ire-related-entities': {
    accessor: 'ire-related-entities',
    component: IreRelatedEntities,
    description: '',
    icon: 'change_circle',
    order: -1,
    title: 'IRE Related Entities',
  },
  'remediation-events': {
    accessor: 'remediation-events',
    component: RemediationEvents,
    description: 'Summary of key remediation events for EID in Rem Hub.',
    icon: 'build_circle',
    order: 8,
    title: 'Remediation Events',
  },
  tags: {
    accessor: 'tags',
    component: Tags,
    description: 'All Tags triggered by EID.',
    icon: 'label',
    order: 7,
    title: 'Tags',
  },
  'trusted-value-history': {
    accessor: 'trusted-value-history',
    component: TrustedValueHistory,
    description: 'Historical changes to IRE Trusted and Untrusted Attributes.',
    icon: 'check_circle',
    order: 9,
    title: 'Trusted Value History',
  },
};
